import { useEffect, useCallback, useRef } from 'react';
import { some } from 'lodash';
export function useClickOutside(callback, ignoreRefs, active) {
    var callbackRef = useRef(callback);
    callbackRef.current = callback;
    var onDocumentClick = useCallback(function (e) {
        if (e.target &&
            some(ignoreRefs, function (ref) { return ref.current && ref.current.contains(e.target); })) {
            return;
        }
        callbackRef.current(e);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ignoreRefs);
    useEffect(function () {
        if (!active)
            return;
        var handler = onDocumentClick;
        document.addEventListener('click', handler, true);
        return function () {
            document.removeEventListener('click', handler, true);
        };
    }, [onDocumentClick, active]);
}
//# sourceMappingURL=useClickOutside.js.map